import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function useProducerTypes() {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			standard: t("producerStandard", "Standard"),
			limited: t("producerLimited", "Limited"),
		}),
		[t],
	);
}
